import { useTranslation } from 'next-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormControl, FormError, Input } from '@Backlot-Cars/archie';
import SignUpHeader from './header';
import SignUpFormActions from './FormActions';
import SignupResumeMessage from './ResumeMessage';

const StepThree = (props) => {
	const { t } = useTranslation('signup');
	const { onSubmit } = props;
	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
	} = useForm({
		defaultValues: {
			password: '',
			password_confirmation: '',
		},
		resolver: yupResolver(props.validationSchema),
	});

	return (
		<>
			<SignupResumeMessage resumeStep={props.resumeStep} backButtonClicked={props.backButtonClicked} />
			<SignUpHeader title={t('signup:steps.step4.title')} subTitle={t('signup:steps.step4.subTitle')} />
			<FormControl label={t('signup:steps.step4.password')} formErrors={errors} required>
				<Input type="password" id="password" autocomplete="off" maxLength="255" {...register('password')} />
			</FormControl>
			<FormControl label={t('signup:steps.step4.confirm')} formErrors={errors} required>
				<Input
					type="password"
					id="passwordConfirmation"
					autocomplete="off"
					maxLength="255"
					{...register('passwordConfirmation')}
				/>
			</FormControl>
			<FormError text={props.error} />
			<SignUpFormActions
				handleSubmit={handleSubmit((values) => onSubmit(values))}
				isSubmitting={isSubmitting}
				backCopy={t('signup:actions.back')}
				nextCopy={t('signup:actions.signUp')}
				{...props}
			/>
		</>
	);
};

export default StepThree;
